export default function($uibModal) {

	return {
		open(content, title, confirmText='Confirm', cancelText='Cancel') {
			return $uibModal.open({
				controller: 'dialogController',
				template: require('./dialog/dialog.html'),
				windowClass: 'dialog',
				resolve: {
					data() {
						return { title, content, confirmText, cancelText }
					}
				}
			}).result;
		}
	}
}


// WEBPACK FOOTER //
// ./app/components/dialog-service.js